<template>
<header>
    <img id="logo" src="../assets/LUMI_dark_1000px.png" alt=""/>
    <nav role="navigation" id="desktop-nav">
        <a href="https://lumi-supercomputer.eu/user-support/" target="_blank" rel="noopener noreferrer">Help & Support</a>
        <a href="https://docs.lumi-supercomputer.eu/" target="_blank" rel="noopener noreferrer">Documentation</a>
        <form action="/login/logout" method="GET"><button type="submit" class="unstyled-button">Logout</button></form>  
    </nav>
    <div v-click-outside="closeMenu">
         <button @click="showMenu = !showMenu" class="unstyled-button" id="menu-button">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24">
                <path d="M3.25 17.625v-1.5h17.5v1.5Zm0-4.875v-1.5h17.5v1.5Zm0-4.875v-1.5h17.5v1.5Z"/>
            </svg>
        </button>  
        <nav role="navigation" v-show="showMenu" id="mobile-nav">
            <ul>
                <li><a @click="closeMenu" href="https://lumi-supercomputer.eu/user-support/" target="_blank" rel="noopener noreferrer">Help & Support</a></li>
                <li><a @click="closeMenu" href="https://docs.lumi-supercomputer.eu/" target="_blank" rel="noopener noreferrer">Documentation</a></li>
                <li><form action="/login/logout" method="GET"><button type="submit" class="unstyled-button">Logout</button></form></li>
            </ul>
        </nav>
    </div>
</header>
</template>

<script>

export default {
    name: "HeaderBar",
    data() {
        return {
            showMenu: false,
        }
    },
    methods: {
        closeMenu() {
            this.showMenu = false;
        }
    }
}
</script>

<style scoped>

header {
    display: flex;
    flex-direction: row;
    height: 6rem;
    width: 100%;
    align-items: center;
    border-bottom: 3px solid var(--light-gray);
}

#logo {
    float: left;
    max-height: calc(100% - 3rem);
    margin-left: 2rem;
}

#desktop-nav {
    float: right;
    margin-right: 1.6rem;
    margin-left: auto;
    display: flex;
    align-items: center;
}

#desktop-nav a {
    padding: 0.6rem 1.2rem;
    font-weight: 700;
}

#desktop-nav a, #desktop-nav form {
    margin: 0 1.25rem;
}

#menu-button, #mobile-nav {
    display: none;
}

#menu-button, #mobile-nav a, #mobile-nav button {
    padding: 0.625rem 1.25rem;
}

#mobile-nav {
    border-top: 1px solid var(--light-gray);
    width: 100%;
    position: absolute;
    top: calc(5rem);
    right: 0;
    background-color: var(--white);
    box-shadow: 0 10px 10px -10px var(--shadow);
}

#mobile-nav li:not(:last-child) {
    padding: 0.625rem 1.25rem;
}

#mobile-nav ul { 
    margin: 0; /**remove default space from ul */
    padding: 0;
    list-style-type: none;
}

#mobile-nav ul > li {
    border-bottom: 1px solid var(--light-gray);
    text-align: center;
}

@media screen and (max-width: 800px) {
    header {
        height: 5rem;
    }
    #desktop-nav a, #desktop-nav form {
        display: none;
    }

    #menu-button, #mobile-nav {
        display: block;
        z-index: 1;
    }
    #desktop-nav {
        margin-right: 1rem;
    }
}

</style>
